import {Box, Flex, useStyleConfig, HStack} from '@chakra-ui/react'
import React, {Fragment, useState} from 'react'
import VerticalLineIcon from '../icons/generic/vertical-line'
import {ChevronLeft, ChevronRight} from '../icons/arrows'
import _ from 'lodash'
import CustomLink from '../custom-link'
import {useGetSovraHeader} from '../../custom-api/hooks/use-get-sovra-header'

const SovraHeader = () => {
    const styles = useStyleConfig('SovraHeader')
    const [currentIndex, setCurrentIndex] = useState(0)

    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    const {data, isFetching, isLoading, isSuccess, isError} = useGetSovraHeader()

    const groupLinkSchema = data?.grouplink

    // Change the current button index, only mobile view
    const switchButton = (direction) => {
        setCurrentIndex((prevIndex) =>
            direction === 'left'
                ? prevIndex === 0
                    ? groupLinkSchema?.length - 1
                    : prevIndex - 1
                : prevIndex === groupLinkSchema?.length - 1
                ? 0
                : prevIndex + 1,
        )
    }

    // Mobile constants
    const isExternalUrl = !!groupLinkSchema?.[currentIndex]?.is_external_url
    const href = groupLinkSchema?.[currentIndex]?.header_link?.href
    const title = groupLinkSchema?.[currentIndex]?.header_link?.title
    return (
        <Flex w="100%" pos="relative" zIndex={1200}>
            {/* Mobile view*/}
            <Box {...styles.container} {...styles.containerMobile}>
                <Flex direction="row" w="100%" align="center" justify="space-between">
                    <ChevronLeft
                        data-testid="left-arrow"
                        {...styles.iconArrow}
                        onClick={() => switchButton('left')}
                    />

                    <CustomLink
                        asButton={true}
                        variant="inverse-icon-button"
                        data-testid={`${_.kebabCase(title)}-current-button-mobile`}
                        isExternal={isExternalUrl}
                        href={href}
                        {...styles.labelSmall}
                    >
                        {title}
                    </CustomLink>

                    <ChevronRight
                        data-testid="right-arrow"
                        {...styles.iconArrow}
                        onClick={() => switchButton('right')}
                    />
                </Flex>
            </Box>
            {/* Desktop view*/}
            <Box {...styles.container} {...styles.containerDesktop}>
                <HStack {...styles.hstack}>
                    {groupLinkSchema?.length > 0 &&
                        groupLinkSchema.map((button, index) => {
                            // block scope constants
                            const isExternalUrl = !!button?.is_external_url
                            const href = button?.header_link?.href
                            const title = button?.header_link?.title
                            return (
                                <Fragment key={index}>
                                    <CustomLink
                                        asButton={true}
                                        variant="inverse-icon-button"
                                        data-testid={`${_.kebabCase(title)}-current-button`}
                                        isExternal={isExternalUrl}
                                        href={href}
                                        {...styles.label}
                                    >
                                        {title}
                                    </CustomLink>

                                    {index < groupLinkSchema.length - 1 && (
                                        <Flex align="center" justify="center" flex="1">
                                            <VerticalLineIcon {...styles.icon} />
                                        </Flex>
                                    )}
                                </Fragment>
                            )
                        })}
                </HStack>
            </Box>
        </Flex>
    )
}

SovraHeader.getTemplateName = () => 'sovra-header'

export default SovraHeader
